<template>
  <ak-tag :color="tagColor" badge>{{ tagValue }}</ak-tag>
</template>

<script>
import Tag from '@akerolabs/akero-vue/src/components/tag/Tag.vue'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AkAppStatusTag',

  components: {
    [Tag.name]: Tag,
  },

  props: {
    app: {
      default: () => ({}),
      type: Object,
    },
  },

  setup(props) {
    /**
     * @type {String}
     * @description The color of the aktag component to render
     */
    const tagColor = computed(() => {
      if (props.app.hidden) return 'warning'
      if (props.app.publishedStatus && !props.app.hidden) return 'success'
      return 'grey'
    })

    /**
     * @type {String}
     * @description The value to put inside the ak-tag component
     */
    const tagValue = computed(() => {
      if (props.app.hidden) return 'Hidden'
      if (props.app.publishedStatus && !props.app.hidden) return 'Published'
      return 'Draft'
    })

    return {
      tagColor,
      tagValue,
    }
  },
})
</script>
